"use client";

import { Row, Col } from "antd";
import "./clinic-blog.scss";
import Link from "next/link";
import { Image as ImageAntd } from "antd";
import moment from "moment";
import defaultImage from "@/public/image/default-image-square.png";
import { Navigation, Scrollbar, Autoplay } from "swiper/modules";
import { SwiperSlide, Swiper } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
export default function ClinicBlog({ clinicBlogs }) {
  // function getFirstWordsFromHTML(htmlContent, wordCount) {
  //   // Create a temporary element to strip HTML tags
  //   const tempElement = document.createElement("div");
  //   tempElement.innerHTML = htmlContent;
  //   const textContent = tempElement.textContent || tempElement.innerText || "";

  //   // Split the text content into words and join the first 'wordCount' words
  //   return textContent.split(/\s+/).slice(0, wordCount).join(" ");
  // }
  const isMobile = typeof window !== "undefined" && window.innerWidth < 768;
  return (
    <div className="wp-clinic-blog">
      {clinicBlogs?.data?.length > 0 ? (
        <Swiper
          modules={[Navigation, Scrollbar, Autoplay]}
          spaceBetween={100}
          loop={true}
          slidesPerView={1}
          autoplay={{ delay: 3000 }}
          pagination={{ clickable: true }}
        >
          {clinicBlogs.data.map((item) => {
            return item?.id ? (
              <SwiperSlide key={item?.id} className="wp-clinic-blog-item">
                <Link
                  href={"/blog/" + item?.slug}
                  prefetch={false}
                  style={{ display: "flex" }}
                >
                  <Row gutter={[16, 16]}>
                    <Col xs={24} md={12} className="wp-clinic-blog-image">
                      <ImageAntd
                        className="clinic-blog-image"
                        src={item?.thumb ? item.thumb : defaultImage}
                        // height={200}
                        preview={false}
                      />
                    </Col>
                    <Col xs={24} md={12}>
                      <h3
                        className="clinic-blog-title"
                        dangerouslySetInnerHTML={{ __html: item?.title }}
                      />
                      {!isMobile && (
                        <div
                          className="clinic-blog-content"
                          dangerouslySetInnerHTML={{ __html: item?.content }}
                        />
                      )}
                      <div className="clinic-blog-date">
                        {moment(item?.date).format("DD/MM/YYYY hh:mm")}
                      </div>
                    </Col>
                  </Row>
                  {/* <div
                    className="clinic-blog-content"
                    // dangerouslySetInnerHTML={{ __html: item?.content }}
                  >
                    {getFirstWordsFromHTML(item?.content, 50)}
                  </div> */}
                </Link>
              </SwiperSlide>
            ) : null;
          })}
        </Swiper>
      ) : (
        <div
          style={{
            color: "#2a3467",
            display: "flex",
            justifyContent: "center",
            fontSize: "16px",
            margin: "12px 0px",
          }}
        >
          Chưa có thông tin
        </div>
      )}
    </div>
  );
}
